export const LOGIN_CAROUSEL_CODE_ID = 'ox-login-carousel';
export const SETTINGS_CAROUSEL_CODE_ID = 'ox-settings-carousel';

export interface ContentfulChannel {
    url: string;
    channelName: string;
}

export const CONTENTFUL_CHANNELS_MAP = new Map<string, ContentfulChannel[]>([
    [LOGIN_CAROUSEL_CODE_ID, [{ url: '/Auth/NewAuth', channelName: 'Login page' }]],
    [SETTINGS_CAROUSEL_CODE_ID, [{ url: '/#/Settings', channelName: 'Settings Page' }]],
]);
